import LocationsMapController from './controller/locations-map';

function routeProvider ($routeProvider) {
    $routeProvider
        .when('/', {
            templateUrl: 'locations-map.html',
            controller: LocationsMapController,
            controllerAs: 'locationsMapVM',
            resolve: {
                locationConfig: ['locationConfigClient', function (locationConfigClient) {
                    return locationConfigClient.getConfig();
                }],
                'translations': ['translationLoader', function (translationLoader) {
                    return translationLoader.ensureTranslations('PayseraMapBundle');
                }]
            }
        })
        .otherwise('/')
    ;
}

routeProvider.$inject = ['$routeProvider'];

export default routeProvider;
